import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import {
	Button,
	Callout,
	Container,
	GraphQLErrorMessage,
	Paragraph,
	Spinner,
	Subheading,
} from '@treams/treams-ui';

const StickyBar = styled(Box)`
	position: sticky;
	top: 0;
	z-index: 2;
	width: 100%;

	@media print {
		display: none;
	}
`;

export default function KeepPreviousAnswersCallout(props: {
	id: string;
	onCompleted?: () => void;
}) {
	const { t } = useTranslation();

	const [discardAnswers, { loading: discarding, error: discardError }] =
		graphql.useDiscardAnswersFromPredecessorMutation({
			onCompleted: () => {
				props.onCompleted?.();
			},
		});

	const [keepAnswers, { loading: keeping, error: keepError }] =
		graphql.useKeepAnswersFromPredecessorMutation({
			onCompleted: () => {
				props.onCompleted?.();
			},
		});

	const loading = discarding || keeping;
	const error = discardError ?? keepError;

	return (
		<StickyBar>
			<Callout color="warning" width="100%" mb={0} p={0} squared>
				<Container py={4}>
					<Box>
						<Box mb={2}>
							<Subheading>{t('evaluation.submission.keepPreviousAnswers.title')}</Subheading>
							<Paragraph>{t('evaluation.submission.keepPreviousAnswers.message')}</Paragraph>
						</Box>
						{error && <GraphQLErrorMessage error={error.graphQLErrors[0]} />}
						{loading ? (
							<Spinner />
						) : (
							<Flex mt={3}>
								<Button
									small
									type="primary"
									title={t('evaluation.submission.keepPreviousAnswers.keep')}
									onClick={() =>
										keepAnswers({
											variables: {
												input: {
													id: props.id,
												},
											},
										})
									}
									mr={2}
								/>
								<Button
									small
									type="secondary"
									title={t('evaluation.submission.keepPreviousAnswers.delete')}
									onClick={() =>
										discardAnswers({
											variables: {
												input: {
													id: props.id,
												},
											},
										})
									}
								/>
							</Flex>
						)}
					</Box>
				</Container>
			</Callout>
		</StickyBar>
	);
}
